<!-- #e3f2fd;-->

  <ul class="nav nav-tabs">
    @if(this.UserService.enableFileProcessing()){
    <li>
      <a routerLink="/pages/File Upload" (click)="setMenu('home')" routerLinkActive="active" id="fileProcessing">File Processing
        <span class="glyphicon glyphicon-upload"></span>
      </a>
    </li>
   }
    <li>
      <a routerLink="/pages/System-Monitoring" (click)="setMenu('home')" routerLinkActive="active">System Monitoring
      </a>
    </li>

  </ul>